export const key = 'coord'

export const process = (chart, config) => {
  if (!config) {
    return chart.coord('rect')
  }

  const { type, ...rest } = config

  const fixType = type || 'rect'

  return chart.coord(fixType, rest)
}
